import { Box, Dialog, DialogContent, IconButton } from '@mui/material'
import { FC, useEffect, useRef, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import ReportPreview from './ReportPreview'
import { ReportPreviewData } from '../../interfaceTypes'
import { Print } from '@mui/icons-material'
import { useReactToPrint } from 'react-to-print'

interface ReportPreviewDialogProps {
  open: boolean
  onClose: () => void
  data: ReportPreviewData[]
  reportGroup: string
  reportSelection: string
  generatedDate: string
  selectionFields: Record<string, any>
}

const ReportPreviewDialog: FC<ReportPreviewDialogProps> = ({
  open,
  onClose,
  data,
  reportGroup,
  reportSelection,
  generatedDate,
  selectionFields
}) => {
  const [isReadyToPrint, setIsReadyToPrint] = useState(false)

  const contentRef = useRef<HTMLDivElement>(null)

  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
    onAfterPrint: () => {
      // setShowPreview(false)
      setIsReadyToPrint(false)
    }
  })

  const handleReadyToPrint = () => {
    setIsReadyToPrint(true)
  }

  useEffect(() => {
    if (isReadyToPrint) {
      handlePrint()
    }
  }, [isReadyToPrint, handlePrint])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: 'calc(100vh - 64px)',
          '@media print': {
            boxShadow: 'none'
          }
        }
      }}
    >
      <Box display={'flex'}>
        <IconButton
          onClick={handleReadyToPrint}
          title="Print"
          sx={{
            position: 'absolute',
            right: 48,
            top: 16,
            color: theme => theme.palette.grey[500],
            '&:hover': {
              color: theme => theme.palette.primary.main
            },
            '@media print': {
              display: 'none'
            }
          }}
        >
          <Print />
        </IconButton>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 16,
            color: theme => theme.palette.grey[500],
            '@media print': {
              display: 'none'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent
        sx={{
          p: 0,
          pt: 2,
          '@media print': {
            p: '0 !important'
          }
        }}
      >
        <ReportPreview
          data={data}
          reportGroup={reportGroup}
          reportSelection={reportSelection}
          generatedDate={generatedDate}
          selectionFields={selectionFields}
          contentRef={contentRef}
        />
      </DialogContent>
    </Dialog>
  )
}

export default ReportPreviewDialog
